import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const faqData = [
  {
    question: "How do I book a cab?",
    answer:
      "You can book a cab by selecting pickup and drop locations, choosing your preferred vehicle type, selecting available cabs, and completing the payment.",
  },
  {
    question: "Can I book a shared cab?",
    answer:
      "Yes, shared cabs are available for all service types — Economy, Standard, and Luxury.",
  },
  {
    question: "Is there a cancellation policy?",
    answer:
      "Yes, you can cancel the ride within 10 minutes of booking for a full refund. After that, a cancellation fee may apply.",
  },
  {
    question: "What payment methods are accepted?",
    answer:
      "We accept UPI, credit/debit cards, net banking, and digital wallets.",
  },
  {
    question: "Can I choose a specific driver or vehicle?",
    answer:
      "At the moment, you can only select a vehicle type. Driver assignment is automatic based on availability.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-12 px-4 md:px-8 font-lato min-h-screen">
      <motion.h2
        className="text-3xl font-bold text-blue-900 mb-12 text-center"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Frequently Asked Questions
      </motion.h2>
      <div className="max-w-3xl mx-auto space-y-6">
        {faqData.map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            className="bg-white border border-blue-100 shadow-xl rounded-2xl"
          >
            <motion.button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center px-8 py-6 text-left text-blue-800 font-semibold focus:outline-none group"
              whileHover={{ scale: 1.03, backgroundColor: "#f0f4ff" }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <span>{faq.question}</span>
              {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </motion.button>
            <AnimatePresence initial={false}>
              {openIndex === index && (
                <motion.div
                  key="answer"
                  initial="collapsed"
                  animate="open"
                  exit="collapsed"
                  variants={{
                    open: { opacity: 1, height: "auto" },
                    collapsed: { opacity: 0, height: 0 }
                  }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="px-8 pb-6 text-gray-700 overflow-hidden"
                >
                  {faq.answer}
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
